/* global google */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Helmet from 'react-helmet';
import { setLocale, I18n, loadTranslations } from 'react-redux-i18n';
import { Promise } from 'bluebird';
import { HotKeys } from 'react-hotkeys';
import { keyMap } from '../../constants/hotkeys';
import SubscriptionAtRisk from '../SubscriptionAtRisk';
const Sidebar = React.lazy(() => import('../../components/sidebar/Sidebar'));
const Loading = React.lazy(() => import('../../components/loadingBar/loading'));
const LoadingSpiner = React.lazy(() =>
  import('../../components/loadingSpiner/LoadingSpiner')
);
const NewBooking = React.lazy(() =>
  import('../../containers/newbooking/NewBooking')
);
const NewIntercityBooking = React.lazy(() =>
  import('../../containers/newIntercityBooking')
);
const NewDeliveryBooking = React.lazy(() =>
  import('../../containers/newDeliveryBooking/NewBookingDelivery')
);
const BookingDetail = React.lazy(() =>
  import('../../components/bookingDetail/BookingDetail')
);
const IntercityBookingDetail = React.lazy(() =>
  import('../newIntercityBooking/IntercityBookingDetail')
);
const DeliveryBookingDetail = React.lazy(() =>
  import('../newDeliveryBooking/DeliveryBookingDetail')
);
const FoodOrderDetail = React.lazy(() =>
  import('../newFoodOrder/FoodOrderDetail')
);

import { logout, loadUserFleet, limitUsageClear } from '../../actions/auth';
import 'react-notifications/lib/notifications.css';
import './App.scss';
import './App-mobile.scss';
import './react-datetime.scss';
import '../../assets/styles/custom.scss';
import '../newbooking/newbooking.scss';
import '../../components/AutoSuggestAirport/index.scss';
import * as menuActions from '../../actions/sidebarCollapsedAction';
import * as commonActions from '../../actions/commonDataAction';
import packageJson from '../../../package.json';
import * as socketActions from '../../actions/socketActions';
import * as mapActions from '../../actions/mapActions';
import * as cueActions from '../../actions/cueActions';
import * as intercityBookingActions from '../../actions/intercityBookingActions';
import * as shuttleAction from '../../actions/shuttleAction';
import {
  socketDispatchApi,
  socketDispatchAuthAsync,
} from '../../utils/socketUtils';
import {
  newBookingRequest,
  closeNewBookingForm,
  resetDataNewBook,
} from '../../actions/newbookingAction';
import * as bookingDetailActions from '../../actions/bookingDetailAction';
import * as reportActions from '../../actions/reportActions';
import * as paymentMethodActions from '../../actions/paymentMethodActions';
import * as notificationActions from '../../actions/notificationActions';
import * as loadingActions from '../../actions/loadingBarActions';
import * as reservationActions from '../../actions/reservationActions';
import * as callCenterSupportActions from '../../actions/callCenterSupportActions';
import * as newbookingActions from '../../actions/newbookingAction';
import * as deliveryAction from '../../actions/deliveryAction';
import * as bookingActions from '../../actions/bookingActions';
import * as quoteAction from '../../actions/quoteAction';
const AppNotifArea = React.lazy(() => import('./AppNotifArea'));
// import AppNotifArea from './AppNotifArea';
// import BookingDetail from '../../components/bookingDetail/BookingDetail';
import ErrorPage from '../misc/ErrorPage';
import PropTypes from 'prop-types';
import _, { cloneDeep, get, forEach, isArray, remove } from 'lodash';
import { translations } from '../../constants/languages/languages';
import { toggleSidebarEvent } from '../../constants/customEvent';
import * as settingActions from '../../actions/settingActions';
import * as corporateActions from '../../actions/corporateAction';
// import { ipCheck, notifyCrashClientAPI } from '../../constants/ApiConfigs';
import {
  isMobile,
  dispatchOuterTableChange,
  getPermissionViewByName,
  notifyCrashToServer,
  postDataCrash,
  checkUserOnboardingNotCompleted,
} from '../../utils/commonFunctions';
import { langaugeCC, userType } from '../../constants/commondata';
import moment from 'moment';
import { Image } from 'react-bootstrap';
import collapseMenuIcon from '../../assets/images/icons/menu_collapsed.svg';
import { socketConfigs } from '../../constants/socketConfigs';
import { handleSubscribeSocketWhenChangeModule } from '../../utils/socketChannelSubcribe';
import { KEY_NAME_SIDEBAR_MODULE } from '../../constants/sidebarMenuConfigs';
import IntercomChat from '../../components/IntercomChat/IntercomChat';
import { SDKProvider } from '@gojo/map-view';
import {
  FLEET_BILLING_MODE,
  FLEET_BILLING_SUBSCRIPTION_STATUS,
  OPEN_BILLING_TOPUP_MODAL_EVENT,
  REFRESH_BILLING_WARNING_AFTER_TOPUP_EVENT,
} from '../billingUsage/utils/constants';
import WarningBilling from '../billingUsage/Tabs/billingOverview/component/WarningBilling';
import { callApiWithoutDispatch } from '../../utils/apiUtils';
import { onBoardingBillingDetailApi } from '../../constants/ApiConfigs';
import SubscriptionCancelled from '../SubscriptionCancelled';
import Welcome from '../../features/welcome';
import { WidgetChat } from '../../features/widget';
import LimitMessage from '../../components/limit-message';
import MigrationBanner, {
  MIGRATION_BANNER_HEIGHT,
  MIGRATION_BANNER_HEIGHT_MOBILE,
  isMigrationBannerEnabled,
} from '../../components/MigrationBanner/MigrationBanner';
import { buildPwaSignInUrl } from '../../utils/pwaSignInUrl';

// import { loadUserProfile } from '../../utils/apiUtils';
require('react-intl-tel-input/dist/libphonenumber.js');
require('react-intl-tel-input/dist/main.css');

notifyCrashToServer();

const preloadCueChunk = () => import('../cue/Cue');

function new_script(src) {
  return new Promise(function (resolve) {
    try {
      var script = document.createElement('script');
      script.src = src;
      script.defer = 'defer';
      script.addEventListener('load', function () {
        resolve();
      });
      script.addEventListener('error', function () {});
      document.body.appendChild(script);
    } catch (error) {
      console.log(error);
    }
  });
}
// Promise Interface can ensure load the script only once.
var my_script = new_script('');

const mapLibraries = {
  google: ['geometry', 'marker', 'places', 'drawing', 'visualization'],
  tencent: ['place', 'drawing', 'geometry', 'autocomplete'],
  apple: [],
  maplibre: [],
  naver: [],
};

class App extends Component {
  constructor() {
    super();
    this.state = {
      AddNew: false,
      notification: [],
      sosNotification: [],
      sos: null,
      appNotification: [],
      isShowComfirm: false,
      isShowMobileSideBar: false,
      billingUsageForWarning: null,
      showMigrationBanner: isMigrationBannerEnabled(),
      pwaSetting: null,
      corpAliasUrl: '',
    };
  }

  UNSAFE_componentWillMount() {
    const { auth } = this.props;
    const { router } = this.context;
    const { pathname, search } = this.props.location;

    // If this page is restricted, go to loginPage first.
    // (But pass on this page's path in order to redirect back upon login)
    if (!auth.user) {
      if (search) {
        router.push(`/login${search}&redirect=${pathname}`);
      } else {
        router.push(`/login?redirect=${pathname}`);
      }
    } else {
      if (auth.user.defaultPw) {
        router.push(`/change-password`);
      } else {
        if (checkUserOnboardingNotCompleted(auth.user || {})) {
          return;
        }
        this.initSystemData();
      }
    }
  }

  handleOpenDetailPage = (params) => {
    this.props.closeNewBookingRequest();
    this.props.intercityBookingActions.closeIntercityBookingForm();
    this.props.deliveryAction.closeDeliveryBookingForm();
    this.props.router.push(params);
  };

  shouldComponentUpdate(nextProps) {
    const { language: { locale: currentLanguage = 'en-US' } = {} } =
      this.props || {};
    const { language: { locale: nextLanguage = 'en-US' } = {} } =
      nextProps || {};
    const { localeCode: currentLocaleCode } = this.props.selectedFleet || {};
    const { localeCode: nextLocaleCode } = nextProps.selectedFleet || {};
    if (
      nextLanguage !== currentLanguage ||
      currentLocaleCode !== nextLocaleCode
    )
      this.updateDatetimeByLanguage(nextLanguage, nextLocaleCode);
    return true;
  }

  componentDidMount() {
    const { language: { locale: language = 'en-US' } = {} } = this.props || {};
    this.updateDatetimeByLanguage(language);
    console.log('Version: ', packageJson.version);
    this.loadBillingUsageForWarning();
    window.addEventListener(
      REFRESH_BILLING_WARNING_AFTER_TOPUP_EVENT,
      this.refreshBillingWarningIfLowBalanceStripWasShown,
    );
    if (this.shouldShowMigrationBanner()) {
      // Recalc sticky tables after banner offset layout is applied
      requestAnimationFrame(() => dispatchOuterTableChange());
    }
  }

  componentWillUnmount() {
    window.removeEventListener(
      REFRESH_BILLING_WARNING_AFTER_TOPUP_EVENT,
      this.refreshBillingWarningIfLowBalanceStripWasShown,
    );
  }

  socketDisconnectedCallback = (fleetid) => {
    this.props.socketActions.socketDisconnected();
    socketDispatchApi.remove(socketConfigs.receive.booking.update_booking);
    socketDispatchApi.remove(socketConfigs.receive.booking.edit);
    socketDispatchApi.remove(socketConfigs.receive.driver.new_driver);
    socketDispatchApi.remove(socketConfigs.receive.driver.set_bookIn);
    socketDispatchApi.remove(socketConfigs.receive.driver.set_bookOFF);
    socketDispatchApi.remove(socketConfigs.receive.driver.set_offline);
    socketDispatchApi.remove(socketConfigs.receive.driver.update_info);
    socketDispatchApi.remove(socketConfigs.receive.driver.update_location);

    socketDispatchApi.remove(socketConfigs.receive.booking.cancel);
    socketDispatchApi.remove(socketConfigs.receive.booking.update);
    socketDispatchApi.remove(socketConfigs.receive.booking.incident);
    socketDispatchApi.remove(socketConfigs.receive.booking.completeWithoutPay);
    socketDispatchApi.remove(socketConfigs.receive.booking.complete);
    socketDispatchApi.remove(socketConfigs.receive.booking.newBooking);
    socketDispatchApi.remove(socketConfigs.receive.booking.rejectBooking);
  };

  socketAuthenticationCallback = (fleetId) => {
    this.props.socketActions.socketAuthenticated(fleetId);
  };

  componentDidUpdate(prevProps) {
    if (this.props.sidebarCollapsed !== prevProps.sidebarCollapsed) {
      window.dispatchEvent(toggleSidebarEvent);
    }
    if (this.props.auth && this.props.auth?.selectedFleet?.fleetId !== prevProps.auth?.selectedFleet?.fleetId) {
      WidgetChat(this.props.auth || prevProps.auth);
      this.loadBillingUsageForWarning();
    }
  }

  updateDatetimeByLanguage = (language, nextLocaleCode) => {
    const localeData =
      moment.localeData(
        'vi'
      ); /* Get VN weekday to fix week is from Mon to Sun */
    const week = localeData._week;
    const localeDatabyLangugage = moment.localeData(language);
    const localeDateDefault = moment.localeData('en');
    moment.locale(language, {
      months: localeDatabyLangugage._months || localeDateDefault._moths,
      monthsShort:
        localeDatabyLangugage._monthsShort || localeDateDefault._monthsShort,
      monthsParseExact: true,
      weekdays: localeDatabyLangugage._weekdays || localeDateDefault._weekdays,
      weekdaysShort:
        localeDatabyLangugage._weekdaysShort ||
        localeDateDefault._weekdaysShort,
      weekdaysMin:
        localeDatabyLangugage._weekdaysMin || localeDateDefault._weekdaysMin,
      weekdaysParseExact: true,
      longDateFormat:
        localeDatabyLangugage._longDateFormat ||
        localeDateDefault._longDateFormat,
      calendar: localeDatabyLangugage._calendar || localeDateDefault._calendar,
      relativeTime:
        localeDatabyLangugage._relativeTime || localeDateDefault._relativeTime,
      dayOfMonthOrdinalParse:
        localeDatabyLangugage._dayOfMonthOrdinalParse ||
        localeDateDefault._dayOfMonthOrdinalParse,
      ordinal: localeDatabyLangugage.ordinal || localeDateDefault.ordinal,
      meridiemParse:
        localeDatabyLangugage._meridiemParse ||
        localeDateDefault._meridiemParse,
      isPM: localeDatabyLangugage.isPM || localeDateDefault.isPM,
      meridiem: localeDatabyLangugage.meridiem || localeDateDefault.meridiem,
      meridiemHour:
        localeDatabyLangugage.meridiemHour || localeDateDefault.meridiemHour,
      week,
    });
  };

  loadedMapCallback = () => {
    console.log('Map script is loaded');
    this.setState({ mapLoad: true });
  };

  doLoad = (link) => {
    my_script = new_script(link);
    window.loadedMapCallback = this.loadedMapCallback;
    my_script
      .then(function () {})
      .catch(function () {
        console.log('error on load map', link);
      });
  };

  validateLanguages = (languagesCode) => {
    if (languagesCode && languagesCode.length > 0) {
      let languages = {};
      Object.keys(translations).map((key) => {
        if (languagesCode.includes(key) || key == 'en-US') {
          languages[key] = translations[key];
        }
      });
      this.props.loadTranslations(languages);
      if (!languages[localStorage.getItem('language')]) {
        this.changeLanguage('en-US');
      } else {
        this.changeLanguage(localStorage.getItem('language'));
      }
    }
  };

  mobileHambergerClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    this.setState({ isShowMobileSideBar: !this.state.isShowMobileSideBar });
  };

  pageContentClickHandle = () => {
    let mobile = isMobile();
    if (mobile) {
      this.setState({ isShowMobileSideBar: false });
    }
  };

  getDefaultLanguage = (settingLanguage, ccLangauge) => {
    const langaugeI18n = langaugeCC[settingLanguage];
    if (ccLangauge.includes(langaugeI18n)) this.props.setLanguage(langaugeI18n);
  };

  checkCountryIsChina = async (data) => {
    const urlParams = new URLSearchParams(window.location.search);
    if (
      urlParams.get('locale') === 'CN' ||
      data?.res?.generalSetting?.useTencentMapOnCC
    ) {
      return true;
    }
    return false;
  };

  getFleetIdFromLocalStorage = () => {
    let fleetObject;
    try {
      fleetObject = JSON.parse(localStorage.getItem('fleet')) || {};
    } catch (err) {
      return '';
    }
    return fleetObject?.fleetId || '';
  };

  socketReconnectCallback = () => {
    this.props.socketActions.socketReconnectAttempt();
    handleSubscribeSocketWhenChangeModule({
      fleetId: this.getFleetIdFromLocalStorage(),
      newModule: this.props?.menuHandle?.key || KEY_NAME_SIDEBAR_MODULE.map,
    });
  };

  initSystemData = async () => {
    let fleetObject;
    try {
      fleetObject = JSON.parse(localStorage.getItem('fleet')) || {};
    } catch (err) {
      fleetObject = {};
    }
    const path = this.props.location.pathname;
    const { menuHandle, commonActions } = this.props;
    const { router } = this.context;

    if (!fleetObject.fleetId) {
      fleetObject = this.props.auth.user.fleetList[0];
      let fleetOwner = this.props.auth.user.fleetList.filter((fl) => {
        return fl.isOwner;
      })[0];
      if (fleetOwner) {
        fleetObject = fleetOwner;
      }
    }
    if (fleetObject?.fleetId) {
      try {
        const payload = await socketDispatchAuthAsync(
          fleetObject.fleetId,
          this.socketReconnectCallback
        );
        this.socketAuthenticationCallback(payload);
        this.setState({ loading: true });
      } catch (e) {
        this.socketDisconnectedCallback();
      } finally {
        this.setState({ loading: false });
      }
    } else {
      this.setState({ loading: false });
    }
    this.props.commonActions.fetchHydraSetting(fleetObject?.fleetId)
    this.props
      .loadUserFleet({ fleetId: fleetObject?.fleetId })
      .then(async (data) => {
        if (data.ok && data.res) {
          localStorage.setItem('fleet', JSON.stringify(fleetObject));
          localStorage.setItem('fleet_country_code', data.res.countryCode);
          const fleetId = fleetObject.fleetId;
          const defaultLanguage = data.res.language;
          if (!localStorage.getItem('language') && defaultLanguage) {
            this.props.setLanguage('es-ES');
            this.getDefaultLanguage(defaultLanguage, data.res.ccLanguages);
          }
          //Check location for map provider
          if (data != null) {
            this.validateLanguages(data.res.ccLanguages);

            // Hide submodule Total adjustment in report when disable edit total fare in Cue
            let menuRoles = cloneDeep(data.res.modules);

            if (
              !data.res.generalSetting ||
              (!data.res.generalSetting.editBookingFare &&
                !data.res.generalSetting.markupPrice)
            ) {
              forEach(menuRoles, (menu) => {
                if (menu.key === 'Report') {
                  if (isArray(menu.actions)) {
                    remove(
                      menu.actions,
                      (sub) => sub.name === 'Total adjustment'
                    );
                  }
                  return false;
                }
              });
            }

            this.props.menuActions.buildMenu(
              this.props.auth.user.isAdmin,
              [
                ...menuRoles,
                {
                  key: 'Notifications',
                  name: 'Notifications',
                  actions: [
                    {
                      name: 'View',
                      isActive: true,
                    },
                    {
                      name: 'Actions',
                      isActive: true,
                    },
                  ],
                },
                {
                  key: 'Sos',
                  name: 'Sos',
                  actions: [
                    {
                      name: 'View',
                      isActive: true,
                    },
                    {
                      name: 'Actions',
                      isActive: true,
                    },
                  ],
                },
                {
                  key: 'SignUpNotifications',
                  name: 'SignUpNotifications',
                  actions: [
                    {
                      name: 'View',
                      isActive: true,
                    },
                    {
                      name: 'Actions',
                      isActive: true,
                    },
                  ],
                },
              ],
              {
                ...data.res.moduleSettings,
                affiliate: data.res.affiliate || {},
                importChauffeurBooking:
                  (data.res &&
                    data.res.generalSetting &&
                    data.res.generalSetting.importChauffeurBooking) ||
                  false,
              },
              this.props.auth.user.roles.moduleAdmin,
              this.props.auth
            );

            commonActions
              .loadBookingFrom(fleetId)
              .then((data) => {
                if (data.ok && data.res) {
                  this.props.cueActions.cueBookingFromFilterList(data.res);
                }
              })
              .catch((error) => {
                console.log(error.error);
              });

            if (isMigrationBannerEnabled() && this.isCorporateUserType()) {
              this.props.settingActions
                .getPWASetting({ fleetId })
                .then((pwaData) => {
                  if (pwaData.ok && pwaData.res && pwaData.res.pwa) {
                    this.setState({ pwaSetting: pwaData.res.pwa });
                  }
                })
                .catch((error) => {
                  console.log(error);
                });

              const corporateId = get(this.props.auth, 'user.corporateId');
              if (corporateId) {
                this.props.corporateActions
                  .detailCorporate({ _id: corporateId, fleetId })
                  .then((detailData) => {
                    const aliasUrl =
                      (detailData.ok &&
                        detailData.res &&
                        detailData.res.aliasUrl) ||
                      '';
                    if (aliasUrl) {
                      this.setState({ corpAliasUrl: aliasUrl });
                    }
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              }
            }
            Promise.all([
              commonActions.getGatewayZones(fleetId),
              commonActions.loadCarType(fleetId),
              commonActions.fetchCurrencies(),
              commonActions.loadOperator(fleetId),
              commonActions.loadMapZone(fleetId, false),
              commonActions.fetchCities(fleetId, false),
              commonActions.fetchCompanies(fleetId, false),
              commonActions.getAllowableDriversAndCars({ fleetId }, false),
              commonActions.loadIntercityRoutesFetchWithCarType(fleetId),
              this.props.paymentMethodActions.paymentMethod(fleetId),
            ])
              .then(() => {
                this.setState({
                  dataLoaded: true,
                });
                preloadCueChunk();
              })
              .catch(() => {
                this.setState({
                  dataLoaded: true,
                });
                preloadCueChunk();
              });

            window.onpopstate = this.backButtonHandle; //browser back button handle
          }
          if (path.length == 0 || path == '/') {
            let menu = null;
            let mapRouter = menuHandle.menuList?.find(
              (item) => item.name == 'Map' && item.show
            );
            if (mapRouter) {
              router.push(mapRouter.link);
              this.sideBarmenuClick(mapRouter.key);
              return;
            }
            menuHandle.menuList.every((m) => {
              if (m.show && m.name !== 'New booking') {
                menu = m;
                return false;
              }
              return true;
            });
            if (menu) {
              router.push(menu.link);
              this.sideBarmenuClick(menu.key);
            }
          }
        } else {
          this.notification(
            'error',
            I18n.t('messages.booking.Can_not_connect_to_server'),
            I18n.t(
              'messages.booking.Check_connection_or_contact_system_support'
            )
          );
        }
      });
  };

  backButtonHandle = () => {
    if (window.location.pathname != '/') {
      let path = window.location.pathname.split('/');
      this.props.menuActions.updateMenu(path);
    } else {
      let menu = null;
      this.props.menuHandle.menuList.every((m) => {
        if (m.show && m.name !== 'New booking') {
          menu = m;
          return false;
        }
        return true;
      });
      if (menu) {
        this.sideBarmenuClick(menu.key);
      }
    }
  };

  closeBookingDialog = () => {
    this.props.resetDataNewBook();
    this.props.bookingDetailActions.bookingDetailClosed();
  };

  notification = (type, title, message, clickHandler, time = 5000) => {
    if (!this.appNotifArea) return;
    this.appNotifArea.notification(type, title, message, clickHandler, time);
  };

  /* handleBookingDetailView = (bookId) => {
        this.props.bookingDetailActions.getBookingDetail(bookId).then(data => {
            if (!data.res || data.error) {
                this.props.bookingDetailActions
                    .getBookingDetail(bookId, true)
                    .then(data => {
                        if (!data.res || data.error) {
                            this.notification(
                                "error",
                                I18n.t("messages.booking.Booking_detail_not_found")
                            );
                        }
                    });
            }
        });
    } */

  getChildContext() {
    return {
      notification: this.notification,
      currenLanguage: this.props.language,
      user: this.props.auth.user,
      reloadCueAnhMap: this.initCueAndDriverData,
    };
  }

  sidebarCollapsedClickHandle = () => {
    if (this.checkDisableMenu()) return;
    this.props.menuActions.sidebarCollapsedAction(!this.props.sidebarCollapsed);
  };

  AddNewBooking = (bookType = 'city') => {
    if (this.checkDisableMenu()) return;
    console.log('AddNewBooking ', bookType);
    this.pageContentClickHandle();
    const { newBooking, intercityBooking, shuttleBooking, deliveryBooking, quoteBooking } =
      this.props;
    if (bookType === 'intercity') {
      if (intercityBooking.isShow) {
        this.props.intercityBookingActions.closeIntercityBookingForm();
      } else {
        this.props.intercityBookingActions.newIntercityBookingRequest();
      }
      this.props.closeNewBookingRequest();
      this.props.shuttleAction.closeShuttleBookingForm();
      this.props.deliveryAction.closeDeliveryBookingForm();
      this.props.quoteAction.closeQuoteBookingForm();
    } else if (bookType === 'shuttle') {
      if (shuttleBooking.isShow) {
        this.props.shuttleAction.closeShuttleBookingForm();
      } else {
        this.props.shuttleAction.newShuttleBookingRequest();
      }
      this.props.intercityBookingActions.closeIntercityBookingForm();
      this.props.deliveryAction.closeDeliveryBookingForm();
      this.props.quoteAction.closeQuoteBookingForm();
      this.props.closeNewBookingRequest();
    } else if (bookType === 'delivery') {
      if (deliveryBooking.isShow) {
        this.props.deliveryAction.closeDeliveryBookingForm();
      } else {
        this.props.deliveryAction.newDeliveryBookingRequest();
      }
      this.props.intercityBookingActions.closeIntercityBookingForm();
      this.props.shuttleAction.closeShuttleBookingForm();
      this.props.quoteAction.closeQuoteBookingForm();
      this.props.closeNewBookingRequest();
    } else if (bookType === 'quote') {
      if (quoteBooking.isShow) {
        this.props.quoteAction.closeQuoteBookingForm();
      } else {
        this.props.quoteAction.newQuoteBookingRequest();
      }
      this.props.intercityBookingActions.closeIntercityBookingForm();
      this.props.deliveryAction.closeDeliveryBookingForm();
      this.props.shuttleAction.closeShuttleBookingForm();
      this.props.closeNewBookingRequest();
    } else {
      if (newBooking.bookingFormShow) {
        this.props.closeNewBookingRequest();
      } else {
        this.props.newBookingRequest(bookType);
      }
      this.props.intercityBookingActions.closeIntercityBookingForm();
      this.props.deliveryAction.closeDeliveryBookingForm();
      this.props.shuttleAction.closeShuttleBookingForm();
      this.props.quoteAction.closeQuoteBookingForm();
    }
  };

  checkDisableMenu = () => {
    return (
      FLEET_BILLING_SUBSCRIPTION_STATUS.past_due ===
        this.props.auth?.selectedFleet?.fleetBilling?.subscription?.status ||
      this.checkCancelBillingStatus()
    );
  };

  sideBarmenuClick = (key, hasSub = false) => {
    if (this.checkDisableMenu()) return;
    this.props.menuActions.sidebarLinkClickAction(
      key,
      this.state.isShowMobileSideBar,
      this.getFleetIdFromLocalStorage()
    );
    this.props.closeNewBookingRequest();
    this.props.intercityBookingActions.closeIntercityBookingForm();
    this.props.deliveryAction.closeDeliveryBookingForm();
    this.props.shuttleAction.closeShuttleBookingForm();
    this.props.quoteAction.closeQuoteBookingForm();
    if (!hasSub) {
      this.pageContentClickHandle();
    }
  };

  quickSaveAction() {
    this.sidebarCollapsedClickHandle();
  }

  changeLanguage = (lang) => {
    this.props.setLanguage(lang);
    dispatchOuterTableChange();
  };

  handleLogout = () => {
    const { user } = this.props;
    socketDispatchApi.close();
    this.props.logout(user);
  };

  buildPageTitle = (menu) => {
    let title = '';
    if (this.props.newBooking.bookingFormShow) {
      title = I18n.t('Sidebar.New_booking');
    } else {
      if (menu) {
        title += I18n.t(menu.text);
        if (menu.sub && menu.sub.length > 0) {
          let sub = menu.sub.filter((mn) => {
            return mn.active && mn.show;
          });
          sub = sub[0] || menu.sub[0];
          title += '/' + this.buildPageTitle(sub);
        }
      }
    }

    return title;
  };

  CheckAccessablePermission(menu) {
    let isAccessable = false;
    if (menu.sub) {
      menu.sub.every((m) => {
        if (m.active) {
          isAccessable = true;
          return false;
        }
        return true;
      });
    }
    return isAccessable;
  }

  componentDidCatch(error, errorInfo) {
    postDataCrash({
      errorMessage: error.message,
      errorStack: error.stack,
    });
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
  }

  handleMapProviderLoaded = () => {
    this.setState({ mapLoad: true });
  };

  checkCancelBillingStatus = () => {
    const { selectedFleet } = this.props;
    const fleetBilling = selectedFleet?.fleetBilling || {};
    if (
      fleetBilling?.subscription?.status ===
      FLEET_BILLING_SUBSCRIPTION_STATUS.canceled
    )
      return true;
    if (fleetBilling?._id && !fleetBilling?.subscription) {
      if (!fleetBilling?.billingDate) return true;
      if (moment(fleetBilling?.billingDate).isBefore(moment())) return true;
    }
    return false;
  };

  checkShowWarningBilling = () => {
    const { selectedFleet } = this.props;
    const fleetBilling = selectedFleet?.fleetBilling || {};
    return (
      FLEET_BILLING_SUBSCRIPTION_STATUS.past_due ===
        fleetBilling?.subscription?.status || this.checkCancelBillingStatus()
    );
  };

  loadBillingUsageForWarning = async () => {
    const fleetId = this.props.auth?.selectedFleet?.fleetId;
    if (!fleetId) {
      if (this.state.billingUsageForWarning != null) {
        this.setState({ billingUsageForWarning: null });
      }
      return;
    }
    try {
      const response = await callApiWithoutDispatch(onBoardingBillingDetailApi, {
        method: 'POST',
        body: JSON.stringify({ fleetId }),
      });
      if (response?.res?.data) {
        this.setState({ billingUsageForWarning: response.res.data });
      }
    } catch (error) {
      console.log(error);
    }
  };

  /** After top-up from billing: refetch App warning snapshot only when the low-balance strip was applicable (same checks as render). */
  refreshBillingWarningIfLowBalanceStripWasShown = () => {
    if (
      this.checkShowLowBalanceBilling() &&
      !this.isFleetBillingAutoFullPageTakeover()
    ) {
      this.loadBillingUsageForWarning();
    }
  };

  checkShowLowBalanceBilling = () => {
    const u = this.state.billingUsageForWarning;
    if (!u) return false;
    if (u.billingMode !== FLEET_BILLING_MODE.auto) return false;
    return (u.creditBalance || 0) + (u.cashBalance || 0) < 0;
  };

  /** When auto billing shows SubscriptionAtRisk / SubscriptionCancelled, skip the global low-balance strip (those screens have their own top banner). */
  isFleetBillingAutoFullPageTakeover = () => {
    const fleetBilling = this.props.selectedFleet?.fleetBilling || {};
    if (fleetBilling?.billingMode !== FLEET_BILLING_MODE.auto) return false;
    if (
      fleetBilling?.subscription?.status ===
      FLEET_BILLING_SUBSCRIPTION_STATUS.past_due
    )
      return true;
    return this.checkCancelBillingStatus();
  };

  /**
   * Corporate portal users see the migration banner too, but Try Now sends
   * them to the booking PWA sign-in instead of the CC → ops reload.
   */
  isCorporateUserType = () => {
    const currentUserType = get(this.props.auth, 'user.userType', '');
    return (
      currentUserType === userType.CorporateAdmin ||
      currentUserType === userType.CorporateUser
    );
  };

  shouldShowMigrationBanner = () => !!this.state.showMigrationBanner;

  handleCorporateMigrationTryNow = () => {
    const corpParam = this.state.corpAliasUrl
      ? `&corp=${encodeURIComponent(this.state.corpAliasUrl)}`
      : '';
    const url = buildPwaSignInUrl(
      this.state.pwaSetting,
      this.props.selectedFleet?.fleetToken,
      `?t=b${corpParam}`,
      this.props.selectedFleet?.pwaLink
    );
    if (url) {
      window.location.href = url;
    }
  };

  checkFleetBillingAutoStatus = () => {
    const { selectedFleet } = this.props;
    const fleetBilling = selectedFleet?.fleetBilling || {};
    const migrationTopOffset = this.shouldShowMigrationBanner()
      ? isMobile()
        ? MIGRATION_BANNER_HEIGHT_MOBILE
        : MIGRATION_BANNER_HEIGHT
      : 0;
    if (fleetBilling?.billingMode === FLEET_BILLING_MODE.auto) {
      if (
        fleetBilling?.subscription?.status ===
        FLEET_BILLING_SUBSCRIPTION_STATUS.past_due
      ) {
        return (
          <SubscriptionAtRisk
            auth={this.props.auth}
            billingUsage={fleetBilling}
            loadingActions={this.props.loadingActions}
            topOffset={migrationTopOffset}
          />
        );
      }
      if (this.checkCancelBillingStatus()) {
        return (
          <SubscriptionCancelled
            auth={this.props.auth}
            loadingActions={this.props.loadingActions}
            topOffset={migrationTopOffset}
          />
        );
      }
    }
    return this.props.children;
  };

  render() {
    if (this.state?.errorInfo) {
      return (
        <ErrorPage
          errorType={'Crash'}
          errorMessage={I18n.t('General.ServerError')}
        />
      );
    }
    const { dataLoaded } = this.state;
    const { router } = this.context;
    let isViewProfile;
    let isViewChangePass, isNewBookingFromUrl;
    let isViewNotifications, isViewSOS, isViewImportBooking;
    const isHasSubscriptionAtRisk = this.checkShowWarningBilling();
    const isLowBalanceBillingWarning =
      this.checkShowLowBalanceBilling() &&
      !this.isFleetBillingAutoFullPageTakeover();
    const isShowMigrationBanner = this.shouldShowMigrationBanner();
    const migrationTopOffset = isShowMigrationBanner
      ? isMobile()
        ? MIGRATION_BANNER_HEIGHT_MOBILE
        : MIGRATION_BANNER_HEIGHT
      : 0;
    let importChauffeurBooking = get(
      this.props.auth,
      'selectedFleet.generalSetting.importChauffeurBooking',
      false
    );
    if (
      this.props.location.pathname === '/newbooking' ||
      this.props.location.pathname === '/cue' ||
      this.props.location.pathname === '/booking-detail'
    ) {
      if (
        getPermissionViewByName(this.props.auth.user, 'New booking', 'Actions')
      ) {
        isNewBookingFromUrl = true;
      }
    }
    if (this.props.location.pathname === '/profile') {
      isViewProfile = true;
    }
    if (this.props.location.pathname === '/change-password') {
      isViewChangePass = true;
    }
    if (this.props.location.pathname === '/notifications') {
      isViewNotifications = true;
    }
    if (this.props.location.pathname === '/sos') {
      isViewSOS = true;
    }
    if (
      this.props.location.pathname === '/import_bookings' &&
      importChauffeurBooking
    ) {
      isViewImportBooking = true;
    }
    const handles = {
      newBooking: this.AddNewBooking,
      quickSave: this.quickSaveAction.bind(this),
    };

    const isValidPages =
      this.props.menuHandle.selectedMainMenu ||
      isViewChangePass ||
      isViewProfile ||
      isViewNotifications ||
      isViewSOS ||
      isNewBookingFromUrl ||
      isViewImportBooking ||
      true;
    const isShowSubmenu =
      this.props.menuHandle.selectedMainMenu &&
      this.props.menuHandle.selectedMainMenu.sub &&
      this.props.menuHandle.selectedMainMenu.sub.length > 0;
    const pageContentClass =
      '' +
      (this.props.sidebarCollapsed ? 'collapsed' : '') +
      (isValidPages &&
      isShowSubmenu &&
      !this.props.newBooking.bookingFormShow &&
      !this.props.intercityBooking.isShow &&
      !this.props.deliveryBooking.isShow &&
      !this.props.shuttleBooking.isShow
        ? ' have-submenu'
        : '');
    let isAirlineBusiness = get(
      this.props.selectedFleet,
      'airlineBusiness.enable'
    );
    let isShuttleNewBooking = get(
      this.props.newBooking.bookingData,
      'isShuttle',
      false
    );
    let isQuoteNewBooking = this.props.quoteBooking.isShow;
    let isIntercityBooking = false;
    let isParcelBooking = false;
    let isFoodBooking = false;
    let isMartBooking = false;
    let isTransportBooking = false;
    let isCrewBooking =
      get(this.props.bookingDetail, 'data.travelerType') === 2;
    if (
      this.props.bookingDetail.isShowing &&
      this.props.bookingDetail.data &&
      !this.props.auth?.user?.roles?.isSupplier
    ) {
      let booking = this.props.bookingDetail.data || {};
      if (booking.intercity) {
        isIntercityBooking = true;
      } else if (booking.superHelper) {
        if (booking.jobType === 'superHelper') {
          isTransportBooking = true;
        } else {
          isParcelBooking = true;
        }
      } else if (booking.delivery) {
        if (
          booking.jobType === 'delivery' ||
          booking.jobType === 'shopForYou'
        ) {
          isParcelBooking = true;
        } else if (booking.jobType === 'food') {
          isFoodBooking = true;
        } else if (booking.jobType === 'mart') {
          isMartBooking = true;
        }
      } else {
        isTransportBooking = true;
      }
    }
    if (
      this.props.auth?.user?.roles?.isSupplier &&
      this.props?.location?.pathname === '/booking-detail'
    ) {
      this.props.router.push({
        pathname: `/supplier-booking-detail/${this.props.location?.query?.bookId}`,
        state: {
          selectedTab:
            this.props.location?.query?.isFinished !== 'FALSE' ? 1 : 0,
        },
      });
    }

    let mapProvider = this.props.selectedFleet?.map?.mapTileCC;
    if (
      mapProvider !== 'google' &&
      mapProvider !== 'apple' &&
      mapProvider !== 'naver'
    ) {
      mapProvider = 'maplibre';
    }
    let naverKey = this.props.selectedFleet?.map?.naverKeys?.cc;
    const mapRoadmapStyleLink = this.props.selectedFleet?.map?.serverUrls?.cc;
    const mapSatelliteStyleLink =
      this.props.selectedFleet?.map?.satelliteStyleUrls?.cc;
    const mapHybridStyleLink =
      this.props.selectedFleet?.map?.hybridStyleUrls?.cc;
    const mapGoogleKey =
      this.props.selectedFleet?.map?.googleKeys?.cc ||
      this.props.selectedFleet?.googleCredential?.apiKey;
    const googleMapId = this.props.selectedFleet?.map?.mapIdLights?.cc;
    const googleMapIdDark = this.props.selectedFleet?.map?.mapIdDarks?.cc;
    const appleKey = this.props.selectedFleet?.map?.appleKeys?.cc;
    const children = this.checkFleetBillingAutoStatus();
    return (dataLoaded &&
      this.props.selectedFleet &&
      this.props.menuHandle.menuList.length > 0) ||
      this.props.defaultPw ? (     <React.Fragment>
      <SDKProvider
        apiKey={
          mapProvider === 'apple'
            ? appleKey
            : mapProvider === 'google'
            ? mapGoogleKey
            : naverKey
        }
        provider={mapProvider}
        libraries={mapLibraries[mapProvider]}
        mapId={googleMapId}
        mapIdDark={googleMapIdDark}
        styleRoadmap={mapRoadmapStyleLink}
        styleSatellite={mapSatelliteStyleLink}
        styleHybrid={mapHybridStyleLink}
        onLoaded={this.handleMapProviderLoaded}
      >
        <LimitMessage auth={this.props.auth} limitUsageClear={this.props.limitUsageClear} />
        {isShowMigrationBanner && (
          <MigrationBanner
            onTryNow={
              this.isCorporateUserType()
                ? this.handleCorporateMigrationTryNow
                : undefined
            }
            onDismiss={() => {
              this.setState({ showMigrationBanner: false }, () => {
                dispatchOuterTableChange();
              });
            }}
          />
        )}
        {isLowBalanceBillingWarning && (
          <WarningBilling
            variant="fixed"
            billingUsage={this.state.billingUsageForWarning}
            topOffset={migrationTopOffset}
            onTopup={() => {
              this.props.router.push(
                '/settings/Billing_usage/overview?action=force-topup-make-payment',
              );
              setTimeout(() => {
                window.dispatchEvent(
                  new CustomEvent(OPEN_BILLING_TOPUP_MODAL_EVENT),
                );
              }, 0);
            }}
          />
        )}
        <IntercomChat />
        {this.state.mapLoad && (
          <HotKeys
            keyMap={keyMap}
            handlers={handles}
            className="fill app-wrapper"
            tabIndex="-1"
          >
            <Helmet
              title={this.buildPageTitle(
                this.props.menuHandle.selectedMainMenu
              )}
            />

            <Loading
              show={this.props.loadingBar.total > 0}
              color="red"
              change={true}
              showSpinner={true}
            />

            <div
              className={`container-content-login fill ${
                this.state.isShowMobileSideBar ? 'mobile' : ''
              } ${isShowMigrationBanner ? 'has-migration-banner' : ''} ${
                isHasSubscriptionAtRisk ? 'has-subscription-at-risk' : ''
              } ${
                isLowBalanceBillingWarning
                  ? 'has-low-balance-billing-warning'
                  : ''
              }`}
            >
              {!isMobile() && (
                <div
                  style={{
                    display: this.props.sidebarCollapsed ? 'none' : 'block',
                  }}
                  className="collapse-icon"
                  onClick={this.sidebarCollapsedClickHandle}
                >
                  <Image src={collapseMenuIcon} />
                </div>
              )}
              <Sidebar
                collapsed={this.props.sidebarCollapsed}
                collapedClickHandle={this.sidebarCollapsedClickHandle}
                isShowSubmenu={isShowSubmenu}
                menuList={
                  this.props.defaultPw ? [] : this.props.menuHandle.menuList
                }
                onMenuClick={this.sideBarmenuClick}
                addNewClick={this.AddNewBooking}
                bookingFormShow={this.props.newBooking.bookingFormShow}
                language={this.props.language}
                languageSelect={this.changeLanguage}
                logout={this.handleLogout}
                translations={this.props.language.translations}
                selectedFleet={this.props.selectedFleet}
                isShuttleNewBooking={isShuttleNewBooking}
                isDisableMenu={this.checkDisableMenu()}
              />
              <div
                id="page-content"
                className={pageContentClass}
                onClick={this.pageContentClickHandle}
              >
                <Welcome props={this.props} context={this.context} />
                {isIntercityBooking && (
                  <IntercityBookingDetail
                    show={this.props.bookingDetail.isShowing}
                    closeBookingDialog={this.closeBookingDialog}
                    data={this.props.bookingDetail.data}
                  />
                )}
                {isParcelBooking && (
                  <DeliveryBookingDetail
                    show={this.props.bookingDetail.isShowing}
                    closeBookingDialog={this.closeBookingDialog}
                    data={this.props.bookingDetail.data}
                    router={this.props.router}
                  />
                )}
                {isFoodBooking && (
                  <FoodOrderDetail
                    show={this.props.bookingDetail.isShowing}
                    closeBookingDialog={this.closeBookingDialog}
                    data={this.props.bookingDetail.data}
                  />
                )}
                {isMartBooking && (
                  <FoodOrderDetail
                    show={this.props.bookingDetail.isShowing}
                    closeBookingDialog={this.closeBookingDialog}
                    data={this.props.bookingDetail.data}
                  />
                )}
                {isTransportBooking && (
                  <BookingDetail
                    show={this.props.bookingDetail.isShowing}
                    closeBookingDialog={this.closeBookingDialog}
                    data={this.props.bookingDetail.data}
                    router={this.props.router}
                    isTransportBooking
                    billingUsage={this.state.billingUsageForWarning}
                  />
                )}
                {this.props.newBooking.bookingFormShow && (
                  <NewBooking
                    onClose={() => {
                      this.props.closeNewBookingRequest();
                    }}
                    isShuttle={false}
                    location={this.props.location}
                    router={router}
                    isTransportBooking
                    billingUsage={this.state.billingUsageForWarning}
                  />)}
                {this.props.intercityBooking.isShow ? (
                  <NewIntercityBooking
                    onClose={() => {
                      this.props.closeNewBookingRequest();
                    }}
                  />
                ) : (
                  ''
                )}
                {this.props.deliveryBooking.isShow ? (
                  <NewDeliveryBooking
                    onClose={() => {
                      this.props.deliveryAction.closeDeliveryBookingForm();
                    }}
                  />
                ) : (
                  ''
                )}

                {this.props.shuttleBooking.isShow && (
                  <NewBooking
                    onClose={() => {
                      this.props.shuttleAction.closeShuttleBookingForm();
                    }}
                    isShuttle
                  />
                )}
                {this.props.quoteBooking.isShow && (
                  <NewBooking
                    onClose={() => {
                      this.props.quoteAction.closeQuoteBookingForm();
                    }}
                    isQuote
                  />
                )}
                <div
                  className="fill-height"
                  style={{
                    display: 'block',
                    // this.props.newBooking.bookingFormShow
                    //   ? "none"
                    //   : "block"
                  }}
                >
                  <AppNotifArea
                    ref={(appNotifArea) => {
                      if (appNotifArea)
                        this.appNotifArea = appNotifArea.getWrappedInstance();
                    }}
                    location={this.props.location}
                    mobileHambergerClick={this.mobileHambergerClick}
                    sidebarCollapsedClickHandle={
                      this.sidebarCollapsedClickHandle
                    }
                    changeLanguage={this.languageSelect}
                    handleLogout={this.handleLogout}
                    sideBarmenuClick={this.sideBarmenuClick}
                    handleOpenDetailPage={this.handleOpenDetailPage}
                    router={this.props.router}
                    isHasSubscriptionAtRisk={isHasSubscriptionAtRisk}
                  />
                  {isValidPages ? (
                    isShowSubmenu ? (
                      <div
                        className="fill"
                        style={{
                          visibility:
                            this.props.newBooking.bookingFormShow ||
                            this.props.intercityBooking.isShow ||
                            this.props.shuttleBooking.isShow ||
                            this.props.quoteBooking.isShow ||
                            this.props.deliveryBooking.isShow
                              ? 'hidden'
                              : 'visible',
                          opacity:
                            this.props.newBooking.bookingFormShow ||
                            this.props.intercityBooking.isShow ||
                            this.props.shuttleBooking.isShow ||
                            this.props.quoteBooking.isShow ||
                            this.props.deliveryBooking.isShow
                              ? 0
                              : 1,
                        }}
                      >
                        {!(
                          this.props.auth?.selectedFleet?.fleetBilling
                            ?.subscription?.status ===
                          FLEET_BILLING_SUBSCRIPTION_STATUS.canceled
                        ) && (
                          <Sidebar
                            sub={true}
                            collapedClickHandle={
                              this.sidebarCollapsedClickHandle
                            }
                            menuList={
                              this.props.menuHandle.selectedMainMenu.sub
                            }
                            bookingFormShow={
                              this.props.newBooking.bookingFormShow
                            }
                            onMenuClick={this.sideBarmenuClick}
                            isMobileShow={this.state.isShowMobileSideBar}
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                            }}
                          />
                        )}
                        <div className="content-with-submenu main-content">
                          {this.CheckAccessablePermission(
                            this.props.menuHandle.selectedMainMenu
                          ) ? (
                            children
                          ) : (
                            <ErrorPage />
                          )}
                        </div>
                      </div>
                    ) : (
                      !this.props.newBooking.bookingFormShow &&
                      !this.props.intercityBooking.isShow &&
                      !this.props.shuttleBooking.isShow &&
                      !this.props.quoteBooking.isShow &&
                      !this.props.deliveryBooking.isShow && (
                        <div
                          className="main-content fill"
                          style={{
                            display: 'block',
                          }}
                        >
                          {children}
                        </div>
                      )
                    )
                  ) : (
                    <ErrorPage errorType="AccessDenied" />
                  )}
                </div>
              </div>
            </div>
            <LoadingSpiner show={this.props.loadingBar.isShowSpiner} />
          </HotKeys>
        )}
      </SDKProvider>
      <IntercomChat />
     </React.Fragment>
    ) : (
      <div className="cssload-thecube">
        <div className="pin" />
        <div className="pulse" />
      </div>
    );
  }
}

App.propTypes = {};

App.contextTypes = {
  router: PropTypes.object.isRequired,
  store: PropTypes.object.isRequired,
};

App.childContextTypes = {
  notification: PropTypes.func,
  currenLanguage: PropTypes.object,
  user: PropTypes.object,
  socket: PropTypes.object,
  reloadCueAnhMap: PropTypes.func,
};

function mapStateToProps(state) {
  const {
    menuHandle,
    i18n,
    auth,
    newBooking,
    loadingBar,
    notification,
    intercityBooking,
    shuttleBooking,
    importBookings,
    deliveryBooking,
    quoteBooking,
  } = state;
  if (menuHandle) {
    return {
      sidebarCollapsed: menuHandle.sidebarCollapsed,
      menuHandle: menuHandle,
      pagetitle: menuHandle.pagetitle,
      language: i18n,
      newbookingFormShowed: menuHandle.newbookingFormShowed,
      defaultPw: auth.user && auth.user.defaultPw,
      auth: auth,
      selectedFleet: auth.selectedFleet,
      newBooking: newBooking,
      intercityBooking: intercityBooking,
      shuttleBooking: shuttleBooking,
      deliveryBooking: deliveryBooking,
      quoteBooking: quoteBooking,
      importBookings: importBookings,
      loadingBar: loadingBar,
      notis: notification,
      bookingDetail: state.bookingDetail,
      callcenterSupport: state.callcenterSupport,
    };
  } else {
    return {
      sidebarCollapsed: false,
      menuHandle: {},
      pagetitle: 'Home',
      language: 'en-US',
      selectedFleet: auth.selectedFleet,
    };
  }
}

function mapDispatchToProps(dispatch) {
  return {
    menuActions: bindActionCreators(menuActions, dispatch),
    setLanguage: (lang) => {
      localStorage.setItem('language', lang);
      dispatch(setLocale(lang));
    },
    loadTranslations: (data) => dispatch(loadTranslations(data)),
    logout: () => dispatch(logout()),
    loadUserFleet: (options) => dispatch(loadUserFleet(options)),
    commonActions: bindActionCreators(commonActions, dispatch),
    socketActions: bindActionCreators(socketActions, dispatch),
    limitUsageClear: () => dispatch(limitUsageClear()),
    intercityBookingActions: bindActionCreators(
      intercityBookingActions,
      dispatch
    ),
    shuttleAction: bindActionCreators(shuttleAction, dispatch),
    quoteAction: bindActionCreators(quoteAction, dispatch),
    deliveryAction: bindActionCreators(deliveryAction, dispatch),
    settingActions: bindActionCreators(settingActions, dispatch),
    corporateActions: bindActionCreators(corporateActions, dispatch),
    newBookingRequest: (value) => dispatch(newBookingRequest(value)),
    closeNewBookingRequest: () => dispatch(closeNewBookingForm()),
    resetDataNewBook: () => dispatch(resetDataNewBook()),
    mapActions: bindActionCreators(mapActions, dispatch),
    cueActions: bindActionCreators(cueActions, dispatch),
    bookingDetailActions: bindActionCreators(bookingDetailActions, dispatch),
    reportActions: bindActionCreators(reportActions, dispatch),
    notificationActions: bindActionCreators(notificationActions, dispatch),
    loadingActions: bindActionCreators(loadingActions, dispatch),
    reservationActions: bindActionCreators(reservationActions, dispatch),
    socketActions: bindActionCreators(socketActions, dispatch),
    paymentMethodActions: bindActionCreators(paymentMethodActions, dispatch),
    callCenterSupportActions: bindActionCreators(
      callCenterSupportActions,
      dispatch
    ),
    newbookingActions: bindActionCreators(newbookingActions, dispatch),
    bookingActions: bindActionCreators(bookingActions, dispatch),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(App);
